<div class="input-otp-container"
     [attr.data-size]="size"
     [attr.data-disabled]="disabled"
     [attr.data-error]="error">
  
  <div class="otp-inputs">
    <ng-container *ngFor="let index of getInputArray(); let i = index">
      <!-- Separator -->
      <span *ngIf="shouldShowSeparator(i)" class="otp-separator">
        {{ separator }}
      </span>
      
      <!-- OTP Input -->
      <input
        #otpInput
        type="text"
        inputmode="numeric"
        pattern="[0-9]*"
        maxlength="1"
        class="otp-input"
        [value]="otpValues[i]"
        [placeholder]="placeholder"
        [disabled]="disabled"
        [attr.aria-label]="'OTP digit ' + (i + 1)"
        [attr.data-index]="i"
        [attr.data-has-value]="!!otpValues[i]"
        (input)="onInput($event, i)"
        (keydown)="onKeyDown($event, i)"
        (paste)="onPaste($event, i)"
        (focus)="onFocus(i)"
        (blur)="onBlur()"
      />
    </ng-container>
  </div>
</div>